import { render } from "./FacialHarmonizationContentEn.vue?vue&type=template&id=6c373d6c"
import script from "./FacialHarmonizationContentEn.vue?vue&type=script&lang=js"
export * from "./FacialHarmonizationContentEn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__